import React, { useEffect } from 'react'
import { buildGroupsKeyValueArray } from './DocSCFunctions'
import SarasChips from '../../../../library/repeater/list/SarasChips'

const DocSearchCriteriaList = (props) => {
    const { viewData, onCriteriaAction } = props;
    const [scList, setSCList] = React.useState([]);

    const initialiseOnDataChange = () => {
        //get the fields list key value pair for the given field dt
        let groupsKeyVal = buildGroupsKeyValueArray(viewData);
        setSCList(groupsKeyVal.list);
    }

    //execute whenever field dt changes - effectively this also will run only once
    useEffect(initialiseOnDataChange, [viewData]);

    const onClick = (anchorRef, rowKey) => {
        if(onCriteriaAction) onCriteriaAction(anchorRef, rowKey, "action-select");
    }

    const onDeleteAction = (rowKey) => {
        if(onCriteriaAction) onCriteriaAction(null, rowKey, "action-delete");
    }

    return (
        <SarasChips className="uiSearchCriteriaChip" chipData={scList} onDelete={onDeleteAction} onClick={onClick}/>
    )
}

export default DocSearchCriteriaList